// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"67f9f07e7ad02ac946ba","691":"83ceb57c450396039d25"}[chunkId] + ".js";
};